import { Button, Text } from '@components/primitives';
import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface BtnPhoneChangeNextProps {
  isLoading?: boolean;
  isDisabled?: boolean;
  performNext?: () => void;
}

const BtnPhoneChangeNext: React.FC<BtnPhoneChangeNextProps> = ({
  isLoading = false,
  isDisabled = false,
  performNext = () => {},
}) => {
  const { t } = useTranslation('common');

  return (
    <Button
      isLoading={isLoading}
      isDisabled={isDisabled}
      variant="solid"
      testID="btnPhoneChangeNext"
      sentry-label="btnPhoneChangeNext"
      paddingY={scale(8)}
      onPress={() => performNext()}>
      <Text testID="txtPhoneChangeNext" variant="sm-bold" color={colors.neutral.cotton}>
        {t('phoneNumberChange.nextButtonText')}
      </Text>
    </Button>
  );
};

export default BtnPhoneChangeNext;
